var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quickstart ma-auto text-center"},[_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.$t('settings.welcome.subtitle'))+" ")]),_c('player',{staticClass:"mt-4",attrs:{"videoId":"Ax2BJvxnBr8"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }